'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { contactChannel } from '@/lib/tracking/contact-link';
import { trackContact, trackSearch } from '@/lib/tracking/events';
const MIN_SEARCH_LENGTH = 2;

/**
 * Ad events that many components can cause. Both are read from one place so a
 * new widget is covered without knowing about tracking: every search box ends
 * up in `?q=`, and every contact button is a link.
 */
export function EventTracker() {
  const $ = _c(4);
  const query = useSearchParams()?.get("q")?.trim() ?? "";
  let t0;
  let t1;
  if ($[0] !== query) {
    t0 = () => {
      if (query.length >= MIN_SEARCH_LENGTH) {
        trackSearch(query);
      }
    };
    t1 = [query];
    $[0] = query;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(_temp, t2);
  return null;
}
function _temp() {
  const onClick = function onClick(event) {
    const link = (event.target as Element | null)?.closest?.("a[href]");
    const channel = contactChannel(link?.getAttribute("href") ?? "");
    if (channel) {
      trackContact(channel);
    }
  };
  document.addEventListener("click", onClick, true);
  return () => document.removeEventListener("click", onClick, true);
}